import { RiFileTextLine } from '@remixicon/react';

import { AttachmentFragment } from '@spotify/confidence-graphql';
import {
  ExternalUrlArtifactContent,
  ExternalUrlArtifactListItem,
  createArtifactExtension,
  getGradientStartColor,
  isGoogleDocUrl,
} from '@spotify/plugin-confidence-projects-react';

import { projectsPlugin } from '../plugin';

const fallbackTitle = (_artifact: AttachmentFragment) => 'Untitled Google Doc';

export const GoogleDocArtifactExtension = projectsPlugin.provide(
  createArtifactExtension({
    id: 'google-doc',
    predicate: artifact => isGoogleDocUrl(artifact.uri),
    icon: () => ({
      Icon: RiFileTextLine,
      color: getGradientStartColor('blue'),
    }),
    label: 'Google Doc',
    category: 'Documents',
    render: artifact => (
      <ExternalUrlArtifactContent
        artifact={artifact}
        fallbackTitle={fallbackTitle}
      />
    ),
    renderListItem: (artifact, { onDelete, onRename, icon }) => (
      <ExternalUrlArtifactListItem
        artifact={artifact}
        icon={icon}
        subtitleLabel="Google Doc"
        openLabel="Open in Google Docs"
        fallbackTitle={fallbackTitle}
        onDelete={onDelete}
        onRename={onRename}
      />
    ),
  }),
);
